import _defineProperty from "/drone/src/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { useMemo } from 'react';
import { DateVector } from '../../utils/DateVector';
export var useDatePickerDaySelectorSelection = function useDatePickerDaySelectorSelection(calendar, dirtyInternalValueVector, selectionStartCandidate, selectionEndCandidate, isDateAllowed, isDateFree) {
  return useMemo(function () {
    var dateStart = dirtyInternalValueVector.dateStart,
      dateEnd = dirtyInternalValueVector.dateEnd;
    var selectionStartDate = dateStart;
    var selectionEndDate = dateEnd;
    if (selectionStartCandidate) {
      selectionStartDate = selectionStartCandidate;
      if (selectionEndCandidate) {
        selectionEndDate = selectionEndCandidate;
        if (selectionEndDate.isSmallerThanOrEqual(selectionStartDate)) {
          var cup = selectionStartDate;
          selectionStartDate = selectionEndDate;
          selectionEndDate = cup;
        }
      } else {
        selectionEndDate = null;
      }
    }
    return calendar.map(function (item) {
      var vector = DateVector.createFromStructure(item);
      var leftEnd = vector.isEqualTo(selectionStartDate);
      var rightEnd = vector.isEqualTo(selectionEndDate);
      var selected = vector.isGreaterThanOrEqual(selectionStartDate) && vector.isSmallerThanOrEqual(selectionEndDate);
      var date = item.date,
        displayedMonth = item.displayedMonth,
        current = item.current;
      var allowed = isDateAllowed(date);
      var free = isDateFree(date);
      return _objectSpread(_objectSpread({}, item), {}, {
        buttonProps: {
          selected: selected,
          allowed: allowed,
          free: free,
          leftEnd: leftEnd,
          rightEnd: rightEnd,
          current: current,
          displayedMonth: displayedMonth
        },
        paddingProps: {
          selected: selected,
          allowed: allowed,
          free: free,
          leftEnd: leftEnd,
          rightEnd: rightEnd,
          current: current,
          displayedMonth: displayedMonth
        }
      });
    });
  }, [dirtyInternalValueVector, selectionStartCandidate, calendar, selectionEndCandidate, isDateAllowed, isDateFree]);
};